import {
    WRITE_REVIEWS_START,
    WRITE_REVIEWS_SUCCESS,
    WRITE_REVIEWS_ERROR
} from '../../constants';
import { showToaster } from '../../helpers/toastrMessgaes/showToaster';
import history from '../../history';
import { writeReviews as mutation, getAllBookings as query } from '../../lib/graphql';
import { setLoaderComplete, setLoaderStart } from '../loader/loader';

export function writeReviewsAction({ userId, bookingId, authorId, ratings, reviewContent, currency }) {

    return async (dispatch, getState, { client }) => {
        try {
            if (!navigator.onLine) {
                showToaster({ messageId: 'networkFailed', toasterType: 'error' })
                return;
            }
            dispatch({
                type: WRITE_REVIEWS_START,
            });
            dispatch(setLoaderStart('reviewLoading'));

            const { data } = await client.mutate({
                mutation,
                variables: {
                    userId,
                    bookingId,
                    authorId,
                    ratings,
                    reviewContent
                },
                refetchQueries: [
                    {
                        query,
                        variables: {
                            currentPage: 1,
                            requestType: 'upcoming',
                            requestCurrency: currency
                        },
                    }
                ]
            })

            if (data?.writeReviews?.status === 200) {
                dispatch(setLoaderComplete('reviewLoading'));
                history.push(`/bookings/upcoming`)
                dispatch({
                    type: WRITE_REVIEWS_SUCCESS,
                });
            } else {
                dispatch(setLoaderComplete('reviewLoading'));
                await showToaster({ messageId: 'errorMessage', toasterType: 'error', requestContent: { content: data?.writeReviews?.errorMessage } })
                dispatch({ type: WRITE_REVIEWS_ERROR });
            }
        } catch (error) {
            dispatch({
                type: WRITE_REVIEWS_ERROR,
                payload: {
                    error,
                },
            });
            return false;
        }
        return true;
    };
}